import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  //when true the full screen loader stands down and a container scoped
  //instance takes over. see LoadingComponent.scoped
  private scopedSubject = new BehaviorSubject<boolean>(false);
  public scoped$ = this.scopedSubject.asObservable();

  constructor() {}

  startLoading() {
    setTimeout(() => this.loadingSubject.next(true));
  }

  stopLoading() {
    this.loadingSubject.next(false);
  }

  useScopedLoader(scoped: boolean) {
    this.scopedSubject.next(scoped);
  }
}
